export default __webpack_public_path__ + "static/media/salesforce.e680044b.jpg";